exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".simple-header-cropped-image .cropped-image{margin-bottom:-3.125rem}@media (min-width:992px){.simple-header-cropped-image .cropped-image{margin-bottom:-7.5rem}}.simple-header-cropped-image .title-section{z-index:1}", ""]);

